export interface AppSettings {
  dir: 'ltr' | 'rtl';
  theme: string;
  sidenavOpened: boolean;
  sidenavCollapsed: boolean;
  boxed: boolean;
  horizontal: boolean;
  activeTheme: string;
  language: string;
  cardBorder: boolean;
  navPos: 'side' | 'top';
  logoDark: string;
  logoLight: string;
}

export const defaults: AppSettings = {
  dir: 'ltr',
  theme: 'light',
  sidenavOpened: true,
  sidenavCollapsed: false,
  boxed: false,
  horizontal: false,
  cardBorder: true,
  activeTheme: 'ukam_theme',
  language: 'en-us',
  navPos: 'side',
  logoDark: './assets/images/logos/dark-logo.svg',
  logoLight: './assets/images/logos/light-logo.svg'
};
